import { styled } from "@mui/material/styles";
import { IoIosArrowForward } from "react-icons/io";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { useState } from "react";

const CustomAccordion = ({ list }) => {
  const [expand, setExpand] = useState("");
  const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    //   '&:not(:last-child)': {
    //     borderBottom: 0,
    //   },
    "&::before": {
      display: "none",
    },
    "& .MuiButtonBase-root": {
      paddingLeft: "25px",
      paddingRight: "25px",
      paddingTop: "15px",
      paddingBottom: "15px",
    },
    "& .MuiAccordionDetails-root": {
      paddingLeft: "25px",
      paddingRight: "25px",
      paddingTop: "0",
    },
    "& .MuiTypography-root": {
      fontSize: "15px",
      fontWeight: "normal",
    },
  }));
  const AccordionSummary = styled((props) => <MuiAccordionSummary expandIcon={<IoIosArrowForward sx={{ fontSize: "0.9rem" }} />} {...props} />)(
    ({ theme }) => ({
      //   backgroundColor:
      //     theme.palette.mode === 'dark'
      //       ? 'rgba(255, 255, 255, .05)'
      //       : 'rgba(0, 0, 0, .03)',
      flexDirection: "row",
      "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(90deg)",
      },
      "& .MuiAccordionSummary-content": {
        //  marginLeft: theme.spacing(1),
        margin: "0",

        fontSize: "15px",
      },
      "& .MuiAccordionSummary-content.Mui-expanded": {
        fontWeight: "bold",
      },
    })
  );
  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    //borderTop: '1px solid rgba(0, 0, 0, .125)',
  }));
  const handleChange = (panel) => (event, newExpanded) => {
    setExpand(newExpanded ? panel : false);
  };
  return (
    <>
      {list?.map((data) => (
        <Accordion expanded={expand === data?.id} onChange={handleChange(data?.id)} key={data?.id}>
          <AccordionSummary expandIcon={<IoIosArrowForward />} aria-controls="panel1-content" id="panel1-header">
            {data?.title}
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{data?.subTitle}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default CustomAccordion;
